<template>
  <z-popover
    class="the-header-help-center-popover"
    position="bottom-right"
  >
    <template #target>
      <z-button variant="tertiary">
        <template #icon>
          <z-icon
            :icon="['far', 'question-circle']"
            size="large"
            color="interactive"
          />
        </template>
      </z-button>
    </template>

    <template #content>
      <div class="the-header-help-center-popover__content">
        <div class="the-header-help-center-popover__body">
          <z-title
            tag="strong"
            align="left"
            size="small"
            color="major"
            class="the-header-help-center-popover__title"
          >
            Como funciona
          </z-title>

          <ol class="the-header-help-center-popover__list">
            <li
              v-for="item in items"
              :key="item.title"
              class="the-header-help-center-popover__item"
            >
              <z-icon
                :icon="item.icon"
                size="medium"
                class="the-header-help-center-popover__item-icon"
              />

              <z-title
                size="nano"
                color="major"
                class="the-header-help-center-popover__item-title"
              >
                {{ item.title }}
              </z-title>

              <z-text
                tag="p"
                color="major"
                size="small"
                class="the-header-help-center-popover__item-description"
                align="left"
              >
                {{ item.description }}
              </z-text>

              <z-divider
                v-if="!item.hideDivider"
                class="the-header-help-center-popover__item-divider"
              />
            </li>
          </ol>
        </div>

        <z-divider />

        <TheHeaderHelpPopoverFooter class="the-header-help-center-popover__footer" />
      </div>
    </template>
  </z-popover>
</template>

<script>
import TheHeaderHelpPopoverFooter from './the-header-help-popover-footer'

export default {
  name: 'TheHeaderHelpPopover',
  components: {
    TheHeaderHelpPopoverFooter,
  },
  computed: {
    items () {
      return [
        {
          title: 'Busque sua bolsa',
          description: 'Escolha um curso e encontre a melhor opção pra você.',
          icon: ['far', 'search'],
        },
        {
          title: 'Garanta sua bolsa',
          description: 'Faça a sua adesão e siga os passos para o processo seletivo.',
          icon: ['far', 'check'],
        },
        {
          title: 'Estude pagando menos',
          description: 'Aí é só realizar a matrícula e mandar ver nos estudos.',
          icon: ['far', 'user-graduate'],
          hideDivider: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.the-header-help-center-popover {
  --z-popover-padding: 0;
}

.the-header-help-center-popover__content {
  min-width: 264px;
}

.the-header-help-center-popover__body {
  padding: var(--unit-0400);
}

.the-header-help-center-popover__title {
  margin-bottom: 0;
  margin-top: 0;
}

.the-header-help-center-popover__list {
  list-style: none;
  margin-bottom: 0;
  margin-top: var(--unit-0400);
  padding-left: 0;
  text-align: left;
}

.the-header-help-center-popover__item {
  align-items: center;
  column-gap: var(--unit-0200);
  display: grid;
  grid-template-areas: (
    'icon title'
    'divider description'
  );
  grid-template-columns: max-content 1fr;
  grid-template-rows: repeat(2, auto);
  justify-items: center;

  & + & {
    margin-top: var(--unit-0200);
  }
}

.the-header-help-center-popover__item-icon {
  grid-area: icon;
}

.the-header-help-center-popover__item-title {
  display: block;
  grid-area: title;
  width: 100%;
}

.the-header-help-center-popover__item-description {
  grid-area: description;
  margin-bottom: 0;
  margin-top: 0;
}

.the-header-help-center-popover__item-divider {
  grid-area: divider;
  margin-top: var(--unit-0100);
}

.the-header-help-center-popover__footer {
  padding: var(--unit-0400);
}
</style>
